/**
 * Lite 路由路徑（SSOT）
 * 集中 path 字串，減少手寫錯誤與重構遺漏
 */

/**
 * Group 脈絡：訂閱方案頁
 */
export function litePathSubscription(): string {
  return '/lite/subscription';
}

/**
 * Group 脈絡：訂閱方案頁並開啟取消訂閱
 */
export function litePathSubscriptionCancel(): string {
  return '/lite/subscription?openCancel=1';
}

/**
 * Group 脈絡：設定頁
 */
export function litePathSetting(): string {
  return '/lite/setting';
}

/**
 * Group 脈絡：建立活動（hold）
 */
export function litePathHold(): string {
  return '/lite/hold';
}

/**
 * Group 脈絡：活動交付頁
 */
export function litePathDeliver(activityId: string): string {
  return `/lite/deliver/${activityId}`;
}

/**
 * Group 脈絡：活動結果頁
 */
export function litePathDeliverResult(activityId: string): string {
  return `/lite/deliver/${activityId}/result`;
}

/**
 * Square 脈絡：商家首頁
 */
export function litePathShop(suffix: string): string {
  return `/lite/shop/${encodeURIComponent(suffix)}`;
}

/**
 * Square 脈絡：訂閱方案頁
 */
export function litePathShopSubscription(suffix: string): string {
  return `/lite/shop/${encodeURIComponent(suffix)}/subscription`;
}

/**
 * Square 脈絡：訂閱方案頁並開啟取消訂閱
 */
export function litePathShopSubscriptionCancel(suffix: string): string {
  return `/lite/shop/${encodeURIComponent(suffix)}/subscription?openCancel=1`;
}

/**
 * Square 脈絡：設定頁
 */
export function litePathShopSetting(suffix: string): string {
  return `/lite/shop/${encodeURIComponent(suffix)}/setting`;
}

/**
 * Square 脈絡：建立活動
 */
export function litePathShopCreateActivity(suffix: string): string {
  return `/lite/shop/${encodeURIComponent(suffix)}/create-activity`;
}

/**
 * Square 脈絡：活動交付頁
 */
export function litePathShopDeliver(
  suffix: string,
  activityId: string
): string {
  return `/lite/shop/${encodeURIComponent(suffix)}/deliver/${activityId}`;
}

/**
 * Square 脈絡：活動結果頁
 */
export function litePathShopDeliverResult(
  suffix: string,
  activityId: string
): string {
  return `/lite/shop/${encodeURIComponent(suffix)}/deliver/${activityId}/result`;
}
